import React, { useRef } from 'react'
import { Block } from '@comp/crRender'
import { useTranslation } from 'react-i18next'
import useForm from '../../../hooks/useForm'
import useFormData from '../../../hooks/useFormData'
import { useUpdate } from '../../../api/hooks'
import { UpdateProviderProfile, UploadProviderPricing } from '../../../api/endpoints/ProviderProfile'
import { SERVICE_TYPES } from '../../../data/Constant'
import ActionBtn from '../../../component/ActionBtn'
import ProviderDetailsSkeleton from '../ProfileData/Components/ProviderDetailsSkeleton'
import {
    EditBasicInformation,
    EditContactInformation,
    EditAccreditations,
    EditSpecialties,
    EditGallery,
    EditCertifications,
    EditKeywords,
    EditVideoSection
} from './sections'
import './style.css'

const EditProfile = ({ providerInfo, isPending, onCancel, onSaveSuccess }) => {
    const { t } = useTranslation()
    const { formHandler, onSubmitFormData } = useForm()
    const { convertToFormData } = useFormData()
    const { onUpdate, isPending: isUpdating } = useUpdate(UpdateProviderProfile)

    const handleSave = () => onSubmitFormData(data => {
        data.append("id", providerInfo?.id)
        data.append("serviceTypeId", SERVICE_TYPES.Medical)

        onUpdate(providerInfo?.id, {
            formData: data,
            onSuccess: () => {
                if (onSaveSuccess) onSaveSuccess()
            }
        })
    })

    // Show skeleton while loading
    if (isPending) {
        return <ProviderDetailsSkeleton isRender={true} />
    }

    return (
        <Block isRender={true} className="hospital-profile-container edit-mode">
            {/* Header with Actions */}
            <div className="hospital-profile-header">
                <h1 className="hospital-profile-title">{t("edit-hospital-portfolio")}</h1>
                <div className="header-actions">

                    <ActionBtn
                        title="save-changes"
                        onApply={handleSave}
                        isDisabled={isUpdating}
                        className="btn-primary"
                    />
                </div>
            </div>

            {/* Main Content Grid */}
            <div className="hospital-profile-grid">
                {/* Left Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    <EditBasicInformation
                        isLoading={isPending}
                        formHandler={formHandler}
                        providerInfo={providerInfo}
                    />

                    <EditAccreditations
                        isLoading={isPending}
                        formHandler={formHandler}
                        providerInfo={providerInfo}
                    />

                    <EditSpecialties
                        isLoading={isPending}
                        formHandler={formHandler}
                        providerInfo={providerInfo}
                    />

                    {/* Gallery and Video in same row */}
                    <div className="media-row">
                        <EditGallery
                            isLoading={isPending}
                            formHandler={formHandler}
                            providerInfo={providerInfo}
                        />
                        <EditVideoSection
                            isLoading={isPending}
                            formHandler={formHandler}
                            providerInfo={providerInfo}
                        />
                    </div>

                    <EditCertifications
                        isLoading={isPending}
                        formHandler={formHandler}
                        providerInfo={providerInfo}
                    />

                    <EditKeywords
                        isLoading={isPending}
                        formHandler={formHandler}
                        providerInfo={providerInfo}
                    />
                </div>

                {/* Right Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    <EditContactInformation
                        isLoading={isPending}
                        formHandler={formHandler}
                        providerInfo={providerInfo}
                    />
                </div>
            </div>
        </Block>
    )
}

export default EditProfile

